import React from 'react';
import { Box, Grid } from '@mui/material';
import { DictionaryAttribute } from '../../../../lib';
import { useIndexList } from '../../contexts/IndexListContext';
import {
    findErrorStateInNestedTree,
    getDefaultExpandedNodeIds,
    getSortedAttributes,
    getUniqueDictionaryTypes,
} from './attribute-helper';
import { DictionaryAttributeEditDrawer } from './DictionaryAttributeEditDrawer';
import { useAttributeList } from '../../contexts/AttributeListContext';
import { MemoAttributeTreeView } from './AttributeTreeView';

interface DictionaryManagerAttributeListProps {
    setIsChangesUnsaved?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DictionaryManagerAttributeList = ({
    setIsChangesUnsaved,
}: DictionaryManagerAttributeListProps): React.JSX.Element => {
    const { indexes } = useIndexList();
    const { attributes, addAttribute, setSelectedAttribute } =
        useAttributeList();

    const sortedData: DictionaryAttribute[] = getSortedAttributes(
        attributes,
        indexes
    );

    const defaultExpandedIds = getDefaultExpandedNodeIds(sortedData, []);
    const uniqueAttributeTypes = getUniqueDictionaryTypes(sortedData);

    // check if the attribute list is valid when is initially loaded.
    const isErrorState: boolean = findErrorStateInNestedTree(sortedData);

    const handleNodeSelected = (attribute: any): void => {
        setSelectedAttribute(attribute.id);
    };

    const handleAddAttribute = (): void => {
        addAttribute();
        setIsChangesUnsaved?.(true);
    };

    return (
        <Grid container>
            <Grid item xs={12}>
                <Box>
                    <MemoAttributeTreeView
                        onNodeSelected={(x: string): void =>
                            handleNodeSelected(x)
                        }
                        handleAddAttribute={handleAddAttribute}
                        attributes={sortedData}
                        defaultExpandedIds={defaultExpandedIds}
                        uniqueAttributeTypes={uniqueAttributeTypes}
                        isErrorState={isErrorState}
                    />
                </Box>
                <DictionaryAttributeEditDrawer
                    setIsChangesUnsaved={setIsChangesUnsaved}
                />
            </Grid>
        </Grid>
    );
};
